export const getMergedFilters = (newFilters, defaultFilters) => {
  if (!defaultFilters?.length) {
    return newFilters;
  }

  const mergedFilters = [];
  const foundFilters = [];
  /**
   * For every filter in default filters find the new value of package count
   */
  defaultFilters.forEach(defaultFilter => {
    /**
     * Find new filter with urlParam equal to default filter
     */
    const newFilter = newFilters.find(filter => filter.urlParam === defaultFilter.urlParam);
    /**
     * Add found filters in an array.
     */
    if (newFilter) {
      foundFilters.push(newFilter?.urlParam);
    }

    /**
     * Update filter stats for merged filter from new filter
     */
    const mergedFilter = {
      ...defaultFilter,
      ...(newFilter || {}),
      listingFilterValues: defaultFilter?.listingFilterValues,
      filterStats: {
        ...defaultFilter?.filterStats,
        discreteStats: defaultFilter?.filterStats?.discreteStats?.map?.(defaultStat => {
          const newStat = newFilter?.filterStats?.discreteStats?.find?.(
            newStat => newStat?.filterValue === defaultStat?.filterValue
          );
          return {
            ...defaultStat,
            packageCount: newStat?.packageCount || 0, // if new filter has value else zero
          };
        }),
      },
    };

    mergedFilters.push(mergedFilter);
  });

  /**
   * If the new filters has a new filter value that is not there in the old
   * filters we add that here. Very edge case. May never happen.
   */

  const remainingNewFilters = newFilters?.filter?.(
    newFilter => !foundFilters?.includes(newFilter?.urlParam)
  );

  return [...mergedFilters, ...remainingNewFilters];
};
